import React, { useEffect } from "react";
import { Body } from "@vds/typography";
import "./ChatLink.css";
import { useDispatch, useSelector } from "react-redux";
import { postSharedCartSaveUrl } from "pages/Checkout/ducks/CheckoutSlice";
const ChatLink = (props) => {
  const isfromAgentLinkPage = useSelector(state=>state?.GlobalData?.fromAgentLinkDealsPage);
  const dispatcher = useDispatch();
  const classApplied = props?.page === 'confirmation' ? 'chat-link-confimation-page': 'chat-link'
  //code for abandon cart chat button onclick scenario
  const params=
  {
    shoppingPath:"PROSPECT",
    fromUCSubmitOrder:false
  }
const triggerApi=()=>{
    dispatcher(postSharedCartSaveUrl(params))
  }
  useEffect(()=>{
    if(props.shippingMethod)
    {
      document.getElementById('eComProspectLP');
      window.addEventListener("click",triggerApi);
      return () => {
        window.removeEventListener('click', triggerApi);
    };
      
    }

  },[props.shippingMethod])
  return (
    !isfromAgentLinkPage ?
    <div className={classApplied} {...props}>
     {/* { sessionStorage.getItem("_chatDisabledI2bD2b") !== 'true' &&  <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon icon-tabler icon-tabler-message-circle"
        width="18"
        height="26"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="#000000"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1" />
        <line x1="12" y1="12" x2="12" y2="12.01" />
        <line x1="8" y1="12" x2="8" y2="12.01" />
        <line x1="16" y1="12" x2="16" y2="12.01" />
      </svg>} */}
      <Body size="large" bold primitive="span">
        <div
          data-LP-event="click"
          id="eComProspectLP"
          data-loc="Content:Button:Confirmation:Chat Now"
          className={`vz-text-link ${props?.from || ''}`}
        ></div>
      </Body>
    </div> : <></>
  );
};

export default ChatLink;
